export const SEQUENCE = {
    name: 'Sequence',
    value: 'SEQUENCE',
    sequence: 1,
};
export const ALPHABETIC = {
    name: 'Alphabetic',
    value: 'ALPHABETIC',
    sequence: 2,
};
const Basic = [SEQUENCE, ALPHABETIC];
const BasicField = [SEQUENCE, ALPHABETIC];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicValues = Object.keys(BasicByValue);
export default {
    Basic,
    BasicField,
    BasicByValue,
    BasicValues,
    SEQUENCE,
    ALPHABETIC,
};
